import { render, staticRenderFns } from "./editDelivery.vue?vue&type=template&id=5f40a3a2&scoped=true"
import script from "./editDelivery.vue?vue&type=script&lang=js"
export * from "./editDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40a3a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f40a3a2')) {
      api.createRecord('5f40a3a2', component.options)
    } else {
      api.reload('5f40a3a2', component.options)
    }
    module.hot.accept("./editDelivery.vue?vue&type=template&id=5f40a3a2&scoped=true", function () {
      api.rerender('5f40a3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/editDelivery.vue"
export default component.exports